<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <template>
            <CallLogStatisticFiltering @filter="fetchData($event)"/>
            <b-row v-if="isLoading">
              <b-col>
                <Loader size="lg"></Loader>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <div v-if="callLogData.rowsdata.length > 0">
                  <table class="table table-sm table-striped table-hover">
                    <thead>
                    <tr>
                      <th>{{ $t('routes.EXCMContractorShow') }}</th>
                      <th>{{ $t('views.excmcalllog.list.answered') }}</th>
                      <th>{{ $t('views.excmcalllog.lastMonthReport.durationSum') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in callLogData.rowsdata" :key="item['@id']">
                      <td>
                        <span v-if="!item.companyId">{{item.firmName}}</span>
                        <router-link v-else-if="item.isCompany === 0" :to="{name: 'UserDataShow', params: { id: '/core/public/index.php/api/user_datas/' + item.companyId }}">
                          {{ item.firmName }}
                        </router-link>
                        <router-link v-else-if="item.isCompany === 1" :to="{name: 'FirmShow', params: { id: '/core/public/index.php/api/user_datas/' + item.companyId }}">
                          {{ item.firmName }}
                        </router-link>
                      </td>
                      <td>{{item.answered}} / {{item.quantity}}</td>
                      <td>{{ item.duration }}</td>
                    </tr>
                    <tr v-if="callLogData.rowsdata.length > 0 && callLogData.summary">
                      <td>{{ $t('views.agreements.form.total') }}</td>
                      <td>{{ callLogData.summary.totalAnswered }} / {{callLogData.summary.totalQuantity}}</td>
                      <td>{{ callLogData.summary.totalDuration }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="form-group pb-2 col-sm-12">
                    <div class="float-right">
                      <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                        <i class="fal fa-file-spreadsheet"></i>
                      </b-button>
                      <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                        <i class="fal fa-spinner fa-spin"></i>
                      </b-button>
                    </div>
                  </div>
                  <hr>
                  <CallLogChart v-if="!isLoadingChart" :callLogData="callLogChartData"/>
                </div>
                <p v-else>{{ $t('views.excmcalllog.list.noItems') }} </p>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import ApiService from '@/utils/ApiService'
import CallLogStatisticFiltering from '@/components/Dashboard/Views/excmcalllog/components/CallLogStatisticFiltering'
import CallLogChart from '@/components/Dashboard/Views/excmcalllog/components/CallLogChart'

export default {
  name: 'CallLogStatisticTable',
  data () {
    return {
      isLoading: true,
      isLoadingChart: true,
      callLogData: [],
      callLogChartData: [],
      downloadXlsStatus: 0,
      params: {}
    }
  },
  components: {
    CallLogChart,
    CallLogStatisticFiltering,
    Loader
  },

  beforeCreate () {
    checkPagePermission('firms', 'EXCMCallLogList')
  },

  created () {
    this.fetchData()
  },

  methods: {
    async fetchData (params = {}) {
      this.params = JSON.parse(JSON.stringify(params))
      this.isLoading = true
      this.fetchChartData(params)
      this.callLogData = await new ApiService('reports/e_x_c_m_call_logs_by_contractor', params).getResults()
      this.isLoading = false
    },
    async fetchChartData (params) {
      this.isLoadingChart = true
      this.callLogChartData = await new ApiService('reports/e_x_c_m_call_logs_last_month', params).getResults()
      this.isLoadingChart = false
    },
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = Object.assign({ xls: 1 }, this.params)
      await new ApiService('reports/e_x_c_m_call_logs_by_contractor', params).downloadFile('call_log_statistics.xls')
      this.downloadXlsStatus = 0
    }
  }
}
</script>
